import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import isNumber from "lodash/isNumber";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
import isBoolean from "lodash/isBoolean";
const operationApi = AiseaApiFactory.get("operation");

class OperationService {
  /**
   * APIでoperationの設定一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {Operation[]} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  async getOperationConfigurations() {
    return await operationApi.index();
  }

  //
  isValidOperation(operation) {
    if (!isObject(operation)) return false;
    const { id, sort_order, service, download_available } = operation;
    return (
      isString(id) && isNumber(sort_order) && isBoolean(download_available)
    );
  }

  calcValidOperations(operations) {
    if (!Array.isArray(operations)) return [];
    return operations.filter(operation => this.isValidOperation(operation));
  }

  sortedValidOperations(operations) {
    return this.calcValidOperations(operations).sort(
      (a, b) => a.sort_order - b.sort_order
    );
  }
}

export default new OperationService();
